import { ListItemIcon, ListItemText, makeStyles, MenuItem } from "@material-ui/core"
import React, { memo } from "react"

const useStyles = makeStyles((theme) => ({
  menuItem: {
    "&:hover": {
      background: theme.palette.primary.shaded.background,
    },
  },
  menuItemShaded: {
    backgroundColor: theme.palette.shaded.main,
    "&:hover": {
      background: theme.palette.shaded.main,
    },
  },
  menuUser: {
    fontSize: 16,
    lineHeight: "16px",
    fontWeight: "600",
    color: theme.palette.text.tinted,
  },
  menuLight: {
    fontSize: 12,
    lineHeight: "16px",
    color: theme.palette.text.light,
  },
  menuListItemIcon: {
    minWidth: "auto",
    paddingRight: theme.spacing(2),
  },
}))

const HeaderMenuItem = ({ onClick, icon, text, children, disabled }) => {
  const classes = useStyles()

  const handleClick = (event) => {
    onClick && onClick(event)
  }

  return (
    <MenuItem className={classes.menuItem} onClick={handleClick} disabled={disabled}>
      {children}
      {!children && (
        <>
          <ListItemIcon className={classes.menuListItemIcon}>{icon}</ListItemIcon>
          <ListItemText primary={text} />
        </>
      )}
    </MenuItem>
  )
}

const MemoHeaderMenuItem = memo(HeaderMenuItem)

export { MemoHeaderMenuItem as HeaderMenuItem }
